import type { ReactNode } from 'react';

/** Shared building blocks, kept small and unstyled beyond the Telegram palette. */

export function Button({
  children,
  onClick,
  variant = 'primary',
  disabled,
  full,
}: {
  children: ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'danger';
  disabled?: boolean;
  full?: boolean;
}) {
  const styles = {
    primary: 'bg-accent text-accent-text',
    secondary: 'bg-surface text-text',
    danger: 'bg-surface text-danger',
  }[variant];

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`rounded-xl px-4 py-2.5 text-[15px] font-medium transition active:scale-[0.97] disabled:opacity-40 ${styles} ${
        full ? 'w-full' : ''
      }`}
    >
      {children}
    </button>
  );
}

export function Card({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <div className={`rounded-2xl bg-surface p-4 ${className}`}>{children}</div>;
}

export function Hint({ children }: { children: ReactNode }) {
  return <p className="text-[13px] text-hint">{children}</p>;
}

export function Spinner() {
  return (
    <div className="h-6 w-6 animate-spin rounded-full border-2 border-hint/30 border-t-accent" />
  );
}

export function Screen({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-full flex-col gap-3 px-3 pt-3 pb-[max(12px,env(safe-area-inset-bottom))]">
      {children}
    </div>
  );
}

export function Centered({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-3 p-6 text-center">
      {children}
    </div>
  );
}
